import { LayoutComponent } from "@jelly/lesson";

import second_order_1 from "./second-order/second-order-1";
import second_order_2 from "./second-order/second-order-2";
import second_order_3 from "./second-order/second-order-3";
import second_order_4 from "./second-order/second-order-4";
import second_order_5 from "./second-order/second-order-5";
import second_order_6 from "./second-order/second-order-6";
import second_order_7 from "./second-order/second-order-7";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 15],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Construction of second order image sources</b>",
                  formatter: "html",
                  scrollbars: false,
                  styles: {
                    textAlign: "center",
                    textTransform: "uppercase",
                    fontSize: "14px",
                    fontWeight: 800,
                    letterSpacing: "3.5px",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "carouselPaginated",
              options: {
                components: [
                  second_order_1,
                  second_order_2,
                  second_order_3,
                  second_order_4,
                  second_order_5,
                  second_order_6,
                  second_order_7,
                ],
              },
            },
          },
        ],
      ],
    },
  },
};

export default component;
